import * as React from 'react';
import * as Api from '../../Api';
import * as B from '../../BasketControl';
import * as Routes from '../../Routes';
import * as Store from '../../Store';
import CheckoutButton from '../CheckoutButton';

interface Props {
  Restaurant: Routes.RouteRestaurant;
  Items: B.Data;
  OnClick: () => any;
  InsideDeliveryZone: boolean;
  translate: any;
  Languages?: Store.Language[];
  AppDesignScheme: Api.AppDesignScheme;
}

interface State {}

export class BottomBar extends React.Component<Props, State> {
  public buttonState = (): boolean => {
    const { InsideDeliveryZone, Items, Restaurant } = this.props;

    switch (Restaurant.status) {
      case 'none':
      case 'pending':
        return true;
      default:
        break;
    }

    // TODO - check against minimun order value.
    const tooFewItems = Items.items.length < 1;

    if (!InsideDeliveryZone) {
      return true;
    }

    if (Restaurant.data.IsOpen) {
      return tooFewItems;
    }

    if (Restaurant.data.AcceptPreOrders) {
      return tooFewItems;
    }

    return true;
  };

  public render(): JSX.Element | null {
    const {
      Restaurant,
      AppDesignScheme,
      Languages,
      Items,
      InsideDeliveryZone,
      OnClick,
      translate
    } = this.props;

    const styles = {
      primary: {
        color: AppDesignScheme.Primary
      }
    };

    switch (Restaurant.status) {
      case 'none':
      case 'pending':
        return null;
      default:
        break;
    }

    let initialLang = 'en';

    if (Languages) {
      for (const Language of Languages) {
        if (Language.active) {
          initialLang = Language.code;
          break;
        }
      }
    }

    const disabled = this.buttonState();

    return (
      <div className="visible-sm-block visible-xs-block">
        <div className="fd-bottom-bar">
          <div
            className={`fd-bar-side fd-bar-side--left  flex flex-align-center flex-justify-center ${
              disabled ? 'fd-bar-side--disabled' : ''
            }`}
          >
            <h4
              className="primary clear-margins text-center"
              style={styles.primary}
            >
              {Items.items.length}
            </h4>
            <i
              className="primary icon_cart"
              style={styles.primary}
              aria-hidden="true"
            />
          </div>

          <div className="fd-bar-box">
            <CheckoutButton
              Style="link"
              IsOpen={Restaurant.data.IsOpen}
              ItemCount={Items.items.length}
              InsideDeliveryZone={InsideDeliveryZone}
              AcceptPreOrders={Restaurant.data.AcceptPreOrders}
              OnClick={OnClick}
              translate={translate}
              AppDesignScheme={AppDesignScheme}
            />
          </div>

          <div
            className={`fd-bar-side fd-bar-side--right flex flex-align-center flex-justify-center ${
              disabled ? 'fd-bar-side--disabled' : ''
            }`}
          >
            <h3 className="primary bold clear-margins" style={styles.primary}>
              {B.ToCurrency(
                B.Total(Items.items),
                Restaurant.data.Currency,
                initialLang
              )}
            </h3>
          </div>
        </div>
      </div>
    );
  }
}

export default BottomBar;
